// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1gE3M","header":"PatientBlock_header__DhdhE","label":"PatientBlock_label__1gd9A","option":"PatientBlock_option__3fvtB"};